<template>
    <div id="harkhan-modal">
        <div class="container">
            <div class="body-modal modal-harkhan">
                <div>
                    <div class="content">
                        <div>
                            <div>
                                <span class="title mobile">{{ data.title }}</span>
                            </div>
                            <img :src="require('@/assets/img/' + data.img)" />
                        </div>
                        <div>
                            <span class="title desktop">{{ data.title }}</span>
                            <div v-html="data.desc" class="desc"></div>
                        </div>
                    </div>
                </div>

                <div class="other-refs">
                    <p>{{ this.modal.type === "functionality" ? $t("message.other_functionality") : $t("message.other_extra") }}</p>

                    <div>
                        <div v-for="(item, idx) in items" :key="idx" @click="displayModal(item.index)">
                            <div>
                                <img :src="require('@/assets/img/' + item.img)" alt="" />
                            </div>
                            <div>
                                <span v-html="item.title"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HarkhanModal",
    data() {
        return {
            local: "fr",
            data: null,
            items: [],
        };
    },
    computed: {
        modal: function () {
            return this.$store.state.app.modal;
        },
        extra: function () {
            return this.$store.state.app.page_fv.extra;
        },
        functionality: function () {
            return this.$store.state.app.page_fv.functionality;
        },
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    beforeMount() {
        this.data = this.$store.state.app.modal.content;
    },
    mounted() {
        this.setItems();
    },
    methods: {
        setItems(newIndex = false) {
            this.local = this.$i18n.locale;

            if (newIndex !== false) {
                this.modal.index = newIndex;
            }

            if (this.modal.type === "extra") {
                let items = this.extra[this.local];

                for (let i = 0; i < items.length; i++) {
                    items[i].index = i;
                    if (this.modal.index !== i) this.items.push(items[i]);
                }
            }

            if (this.modal.type === "functionality") {
                let items = this.functionality[this.local];

                for (let i = 0; i < items.length; i++) {
                    items[i].index = i;
                    if (this.modal.index !== i) this.items.push(items[i]);
                }
            }
        },
        displayModal(index) {
            this.items = [];
            if (this.modal.type === "functionality") {
                this.data = this.$store.state.app.page_fv.functionality[this.local][index];
                this.setItems(index);
            }
            if (this.modal.type === "extra") {
                this.data = this.$store.state.app.page_fv.extra[this.local][index];
                this.setItems(index);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#harkhan-modal {
    background: url("@/assets/img/bg_modal_harkhan.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 100%;
    display: flex;
    //padding: 6rem 0;
    box-sizing: border-box;

    .modal-harkhan {
        padding: 6rem 0;
        box-sizing: border-box;

        > div {
            max-width: 1400px;
            margin: auto;
        }

        .content {
            display: flex;
            flex-flow: row nowrap;

            > div {
                &:first-child {
                    width: 50%;
                    flex: 0 0 50%;
                    padding-right: 2rem;
                    box-sizing: border-box;

                    img {
                        border-radius: 15px;
                        overflow: hidden;
                        width: 100%;
                        border: 0;
                    }
                }

                &:last-child {
                    width: 50%;
                    flex: 0 0 50%;
                    display: flex;
                    flex-flow: column;
                }
            }
        }

        .title {
            font-family: Oswald, sans-serif;
            color: #0c143a;
            font-size: 2.2rem;
            padding: 0;
            font-weight: 700;

            &.mobile {
                display: none;
            }
        }

        .desc {
            color: #0c143a;
            padding: 0;
            font-size: 1.2rem;
            font-weight: 300;
        }
    }

    .other-refs {
        > p {
            font-family: Oswald, sans-serif;
            color: #0c143a;
            font-size: 1.4rem;
            margin-top: 4rem;
        }

        > div {
            display: flex;
            flex-flow: row nowrap;
            align-items: stretch;
            width: 100%;

            > div {
                flex: 0 0 33.33333333%;
                overflow: hidden;
                background-color: #0c143a;
                display: flex;
                flex-flow: row nowrap;
                align-items: center;
                border-radius: 8px;
                color: #fff;
                cursor: pointer;
                padding: 1rem;
                box-sizing: border-box;
                transition: all 0.3s;
                font-family: Oswald, sans-serif;

                &:nth-child(2) {
                    margin: 0 1rem;
                }

                &:hover,
                &:focus {
                    transform: scale(1.05);
                    z-index: 1;
                }

                > div {
                    &:first-child {
                        flex: 1;

                        img {
                            width: 100%;
                            display: block;
                            border-radius: 8px;
                        }
                    }

                    &:last-child {
                        flex: 2;
                        padding-left: 1rem;
                        box-sizing: border-box;
                    }
                }
            }
        }
    }
}

@media (max-width: 1400px) {
    #harkhan-modal .modal-harkhan {
        .content {
            > div {
                &:first-child {
                    width: 60%;
                    flex: 0 0 60%;
                    padding-right: 2rem;
                }

                &:last-child {
                    width: 40%;
                    flex: 0 0 40%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 2rem;
        }

        .desc {
            font-size: 1.2rem;
        }

        .comment {
            font-size: 1.2rem;
        }

        .tags {
            padding: 1rem 0 0;

            span {
                margin-right: 0.6rem;
                padding: 0.5rem;
            }
        }
    }

    #harkhan-modal .other-refs {
        > p {
            font-size: 1.4rem;
            margin-top: 4rem;
        }

        > div {
            > div {
                flex: 0 0 33.33333333%;
                padding: 1rem;

                > div {
                    &:last-child {
                        padding-left: 1rem;
                    }
                }
            }
        }
    }
}
@media (max-width: 1200px) {
    #harkhan-modal .modal-harkhan {
        .content {
            > div {
                &:first-child {
                    width: 60%;
                    flex: 0 0 60%;
                    padding-right: 2rem;
                }

                &:last-child {
                    width: 40%;
                    flex: 0 0 40%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 1.8rem;
        }

        .desc {
            font-size: 1.1rem;
        }

        .comment {
            font-size: 1.1rem;
        }

        .tags {
            padding: 1rem 0 0;

            span {
                margin-right: 0.6rem;
                padding: 0.5rem;
            }
        }
    }

    #harkhan-modal .other-refs {
        > p {
            font-size: 1.3rem;
            margin-top: 4rem;
        }

        > div {
            > div {
                flex: 0 0 33.33333333%;
                padding: 1rem;

                > div {
                    &:last-child {
                        padding-left: 1rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 992px) {
    #harkhan-modal .modal-harkhan {
        .content {
            flex-flow: column;

            > div {
                &:first-child {
                    width: 100%;
                    flex: 0 0 100%;
                    padding-right: 0;
                }

                &:last-child {
                    width: 100%;
                    flex: 0 0 100%;

                    > div:last-child {
                        margin-bottom: 2rem;
                    }
                }
            }
        }

        .title {
            font-size: 1.8rem;

            &.desktop {
                display: none;
            }

            &.mobile {
                display: block;
                margin-bottom: 0.7rem;
            }
        }

        .desc {
            font-size: 1.1rem;
        }

        .comment {
            font-size: 1.1rem;
        }

        .tags {
            padding: 1rem 0 0;

            span {
                margin-right: 0.6rem;
                padding: 0.5rem;
            }
        }
    }

    #harkhan-modal .other-refs {
        > p {
            font-size: 1.2rem;
            margin-top: 3rem;
        }

        > div {
            flex-flow: column;

            > div {
                flex: 0 0 100%;
                padding: 1rem;
                margin-bottom: 1rem;

                > div {
                    &:last-child {
                        padding-left: 1rem;
                    }
                }

                &:nth-child(2) {
                    margin: 0;
                    margin-bottom: 1rem;
                }

                &:hover,
                &:focus {
                    transform: scale(1.02);
                }
            }
        }
    }
}

@media (max-width: 768px) {
    #harkhan-modal .modal-harkhan {
        padding: 4rem 0;
    }
}

@keyframes opacity-in {
    100% {
        opacity: 1;
    }
}
</style>
